import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/images/pc_logo.png';
import _imports_1 from '@/assets/images/pc_slogan_01.png';
import _imports_2 from '@/assets/images/pc_slogan_02.png';
import _imports_3 from '@/assets/images/pc_download_btn.png';
import _imports_4 from '@/assets/images/pc_online_service.png';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "pc-logo m-auto",
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "pc-slogan-01 m-auto",
  src: _imports_1,
  alt: ""
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "pc-slogan-02 m-auto",
  src: _imports_2,
  alt: ""
}, null, -1);
const _hoisted_4 = {
  class: "pc-qrcode m-auto"
};
const _hoisted_5 = {
  class: "pc-qrcode-bg"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "pc-download-btn m-auto",
  src: _imports_3,
  alt: ""
}, null, -1);
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = ["href"];
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  class: "d-tutorial"
}, "使用教程", -1);
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  key: 3,
  class: "wxtip",
  id: "Tip"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "wxtip-icon"
}, null, -1);
const _hoisted_14 = [_hoisted_13];
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';
import QrcodeVue from 'qrcode.vue';
import { showLoadingToast, closeToast, showNotify } from 'vant';
import { AES } from '../../utils/crypto-helper';
const APP_SCHEME = 'bitong://';
const APP_LINKS = 'https://wwww.bitong.co/pay';
export default {
  __name: 'index',
  setup(__props) {
    const userAgent = navigator.userAgent;
    // const BASE_URL = 'https://api2.wallet.huw10086.com';
    // const BASE_URL = 'https://app.bitongapi.com';
    const route = useRoute();
    const {
      tid
    } = route.query;
    const value = ref(window.location.href);
    const level = ref('M');
    const size = ref(160);
    const tokenAmount = ref(0);
    const renderAs = ref('svg');
    const downloadLink = ref('');
    const websiteLink = ref('');
    const liveLink = ref('');
    function isWX() {
      // return true;
      var ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    }
    async function getConfig() {
      try {
        showLoadingToast({
          duration: 0,
          message: '加载中...',
          forbidClick: true
        });
        const {
          status,
          data
        } = await axios.get(window.location.origin + '/api/config/info');
        if (status == 200) {
          let finData = data;
          if (data.encrypt_data) {
            finData = JSON.parse(AES.AES_CBC_DECRYPT(data.encrypt_data));
          }
          const {
            ad_down,
            ios_down,
            live_url,
            website
          } = finData.data;
          websiteLink.value = website + "/tutorial/";
          if (/iPhone|iPad|iPod/i.test(userAgent)) {
            // 用户使用的是iOS设备
            downloadLink.value = ios_down;
          } else {
            // 既不是Android也不是iOS
            downloadLink.value = ad_down;
          }
          liveLink.value = live_url;
        }
      } catch (error) {
        console.error(error);
      } finally {
        closeToast();
      }
    }
    function onServiceClick() {
      window.open(liveLink.value, '_blank');
    }
    onMounted(() => {
      getConfig();
      var width = window.innerWidth;
      size.value = Math.ceil(width * (144 / 750));
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(QrcodeVue, {
        value: value.value,
        level: level.value,
        "render-as": renderAs.value,
        size: size.value,
        style: {
          "width": "100%",
          "height": "100%"
        }
      }, null, 8, ["value", "level", "render-as", "size"])])]), downloadLink.value != '' ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        target: "_blank",
        tabindex: "0",
        href: downloadLink.value
      }, _hoisted_8, 8, _hoisted_6)) : _createCommentVNode("", true), websiteLink.value != '' ? (_openBlock(), _createElementBlock("a", {
        key: 1,
        target: "_blank",
        href: websiteLink.value
      }, _hoisted_11, 8, _hoisted_9)) : _createCommentVNode("", true), liveLink.value != '' ? (_openBlock(), _createElementBlock("img", {
        key: 2,
        src: _imports_4,
        style: {
          "width": "auto",
          "height": "auto",
          "position": "fixed",
          "bottom": "2rem",
          "right": "2rem",
          "z-index": "9999"
        },
        onClick: onServiceClick
      })) : _createCommentVNode("", true), isWX() ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)) : _createCommentVNode("", true)], 64);
    };
  }
};